import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Text } from '@fly/core';
import { Separator } from '@radix-ui/themes';
import { DropdownMenu } from '@radix-ui/themes';

interface FlyFilterByPromptProps {
  query: string | undefined;
  clear: () => void;
  /** Trigger button label; defaults to app.common.prompt_filter. */
  triggerText?: string;
  /** Dropdown header label; defaults to app.common.prompt_filter. */
  headerText?: string;
}

export const FlyFilterByPrompt = ({
  query,
  clear,
  triggerText,
  headerText,
}: FlyFilterByPromptProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const icon = !query ? false : isOpen ? 'chevron_up' : 'chevron_down';
  const defaultPromptLabel = t('app.common.prompt_filter', {
    defaultValue: 'Filter by prompt',
  });
  const resolvedTriggerText = triggerText ?? defaultPromptLabel;
  const resolvedHeaderText = headerText ?? defaultPromptLabel;

  return (
    <div className='min-w-0 gap-2 flex max-w-full'>
      <DropdownMenu.Root open={isOpen} onOpenChange={setIsOpen}>
        <DropdownMenu.Trigger>
          <Button
            className='!mr-0 min-w-0 max-w-full truncate'
            variant='soft'
            size='1'
            iconEnd={icon}
          >
            {resolvedTriggerText}
          </Button>
        </DropdownMenu.Trigger>
        {query && (
          <DropdownMenu.Content>
            <div className='ml-3 mr-3 flex max-w-[300px] flex-col gap-fly-3 overflow-hidden'>
              <Text size='2' className='mb-1 flex-1' color='neutral'>
                {resolvedHeaderText}
              </Text>
              <Text size='2' className='whitespace-pre-line'>
                {query}
              </Text>
              <Separator orientation='horizontal' size='4' />
            </div>
            <Button
              variant='ghost'
              color='neutral'
              size='1'
              iconStart='cross_circled'
              onClick={clear}
              className='mt-2 ml-1 w-fit justify-start'
            >
              {t('app.common.actions.clear', { defaultValue: 'Clear' })}
            </Button>
          </DropdownMenu.Content>
        )}
      </DropdownMenu.Root>
    </div>
  );
};
